/* ============================================================
   US-Parts24 · R512 — Marken-Band (sections/usparts-marken-band).

   Zwei Zeilen laufen gegenläufig mit Grundtempo; die Scroll-
   geschwindigkeit gibt einen Schub in Scrollrichtung. Ein transform je
   Zeile und Bild, nur solange das Band im Bild ist (IntersectionObserver
   mit dem echten Scroller als root). Breiten werden nur beim Start und
   bei Größenänderung gemessen.
   ============================================================ */
(function () {
  'use strict';
  var wurzeln = document.querySelectorAll('[data-usp-marken]');
  if (!wurzeln.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.Shopify && window.Shopify.designMode) return;

  Array.prototype.forEach.call(wurzeln, function (wurzel) {
    var zeilen = Array.prototype.map.call(wurzel.querySelectorAll('[data-usp-marken-zeile]'), function (z) {
      var spur = z.querySelector('[data-usp-marken-spur]');
      return { spur: spur, richtung: parseFloat(z.getAttribute('data-richtung')) || -1, x: 0, breite: 0, zuletzt: null };
    }).filter(function (z) { return z.spur; });
    if (!zeilen.length) return;

    var tempo = parseFloat(wurzel.getAttribute('data-tempo')) || 45;   // px/s
    var desktop = window.innerWidth >= 990;
    var scroller = desktop ? document.querySelector('.page-wrapper') : null;
    function oben() { return scroller ? scroller.scrollTop : (window.scrollY || document.documentElement.scrollTop); }

    function messen() {
      zeilen.forEach(function (z) {
        var g = z.spur.firstElementChild;
        z.breite = g ? g.getBoundingClientRect().width : 0;   // eine Gruppe = eine Runde
      });
    }

    var laeuft = false, zuletztT = 0, zuletztOben = oben(), schub = 0;
    function takt(t) {
      if (!laeuft) return;
      var dt = zuletztT ? Math.min(0.05, (t - zuletztT) / 1000) : 0;
      zuletztT = t;
      /* Scrollgeschwindigkeit: bevorzugt von Lenis, sonst aus der Differenz */
      var l = window.uspSmooth && window.uspSmooth.lenis;
      var jetzt = oben();
      var v = l && typeof l.velocity === 'number' ? l.velocity : (jetzt - zuletztOben);
      zuletztOben = jetzt;
      schub += (Math.max(-60, Math.min(60, v)) - schub) * 0.12;   // geglättet, gedeckelt
      zeilen.forEach(function (z) {
        if (!z.breite) return;
        z.x += z.richtung * (tempo * dt + Math.abs(schub) * 0.9) * (schub < -0.5 ? -1 : 1);
        if (z.x <= -z.breite) z.x += z.breite;
        if (z.x > 0) z.x -= z.breite;
        var gerundet = Math.round(z.x * 2) / 2;
        if (gerundet !== z.zuletzt) { z.zuletzt = gerundet; z.spur.style.transform = 'translate3d(' + gerundet + 'px,0,0)'; }
      });
      requestAnimationFrame(takt);
    }
    function an() { if (laeuft) return; laeuft = true; zuletztT = 0; zuletztOben = oben(); requestAnimationFrame(takt); }
    function aus() { laeuft = false; }

    messen();
    zeilen.forEach(function (z) { if (z.richtung > 0) z.x = -z.breite / 2; });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(messen);
    var mt = null;
    window.addEventListener('resize', function () { clearTimeout(mt); mt = setTimeout(messen, 150); }, { passive: true });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) an(); else aus(); });
      }, { root: scroller || null, rootMargin: '10% 0px 10% 0px' }).observe(wurzel);
    } else { an(); }
    document.addEventListener('visibilitychange', function () { if (document.hidden) aus(); });
  });
})();
